import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { storeDateFormat } from '../constants'

dayjs.extend(utc)
dayjs.extend(timezone)

const toStoreDay = (value, timeZone) => {
  if (typeof value === 'string') return dayjs(value).tz(timeZone)

  return value
}

export const toStoreDateString = (value, timeZone) => {
  if (!value) return null

  return toStoreDay(value, timeZone).format(storeDateFormat)
}
